var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "rack"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('orders.orderNum')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.listOrderMasterdata.poid))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Order Date")]), _vm._v(" "), _c('td', [(_vm.listOrderMasterdata.createddatetime != null) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.listOrderMasterdata.createddatetime)))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Payment Mode")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.listOrderMasterdata.paymentmode))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Order Status")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.listOrderMasterdata.status || _vm.toUpper))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Updated By")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.listOrderMasterdata.createdby))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Last Updated Date")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dateFormatDetail(_vm.listOrderMasterdata.createddatetime)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Total No Of Product")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.totalitems))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Total Quantity")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.totalorderqty))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Net Payment")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.totalamount))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Shipping Charges")]), _vm._v(" "), _c('td', [(_vm.shipcount != 0) ? _c('span', [_vm._v(_vm._s(_vm.shipMasterData.shippingamount))]) : _c('span', [_vm._v("0")])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Discount")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.discount))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("COD Charges")]), _vm._v(" "), _c('td', [(_vm.listOrderMasterdata.codamount) ? _c('span', [_vm._v(_vm._s(_vm.listOrderMasterdata.codamount))]) : _c('span', [_vm._v("0")])])]), _vm._v(" "), _vm._m(2)])])])])])])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_vm._m(3), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Address:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.listOrderMasterdata.custaddress1) + " " + _vm._s(_vm.listOrderMasterdata.custcity) + ", " + _vm._s(_vm.listOrderMasterdata.custpincode))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Mobile No: ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.listOrderMasterdata.custmobile))])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Courier Service:")]), _vm._v(" "), _c('td', [(_vm.shipcount != 0) ? _c('span', [_vm._v(_vm._s(_vm.shipMasterData.shippingcompany))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Order By:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.listOrderMasterdata.customerfirstname) + " " + _vm._s(_vm.listOrderMasterdata.customerlastname))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Order Time:")]), _vm._v(" "), _c('td', [(_vm.listOrderMasterdata.orderdate != null) ? _c('span', [_vm._v(_vm._s(_vm.dateFormatDetail(_vm.listOrderMasterdata.orderdate)))]) : _vm._e()])])])])])])])], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Order Details")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Payment Status")]), _vm._v(" "), _c('td')])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Cash Refund Use")]), _vm._v(" "), _c('td', [_vm._v("0")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Shipping Details")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Instruction:")]), _vm._v(" "), _c('td', [_vm._v("N/A")])])
}]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9dc198fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9dc198fe","hasScoped":true}!./src/views/components/orderdetailstab/orderdetails/orderdetails.component.html
// module id = 1387
// module chunks = 0